import { Route, Redirect } from 'react-router-dom';
import { useAccount } from '../Context/AccountProvider';
import { LoadingSpinner } from './LoadingSpinner';

export function CreatorRoute({ component: Component, ...rest }) {
    const { accountInfo } = useAccount();

    return (
        <Route {...rest} render={(props) => {
            if (accountInfo.loading) {
                return <LoadingSpinner />;
            }
            if (!accountInfo.loggedIn || !accountInfo.user?.isCreator) {
                return <Redirect to="/" />;
            }
            return <Component {...props} />;
        }} />
    );
}
